import React from 'react';
import { ImageApis } from '../../../../commonv3/api/images';
import './practicalSectionEyeCatch.module.scss';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../../routes';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';

const SubmissionBannerForDesktop = ({ sectionId, submissionPlaceUrl }) => {
  return (
    <div styleName="submission-cta" className="practical-section-submission-banner">
      <div styleName="cta-text1">準備ができたら提出しよう</div>
      <div>
        <Button
          styleName="button"
          type="primary"
          size="ms"
          className="practical-section-submission-link"
          to={V3Routes.examPracticalSectionSubmissionNew(sectionId)}
        >
          提出する
        </Button>
        <a
          href={submissionPlaceUrl}
          styleName="practical-section-submissions-index-link"
          className="practical-section-submissions-index-link"
          target="_blank"
        >
          他の人の提出内容を見る
        </a>
      </div>
    </div>
  );
};

const SubmissionBannerForSp = ({ submissionPlaceUrl }) => {
  return (
    <div styleName="submission-cta">
      <div styleName="cta-text1">PCからのみ提出可能です</div>
      <a href={submissionPlaceUrl} styleName="practical-section-submissions-index-link" target="_blank">
        他の人の提出内容を見る
      </a>
    </div>
  );
};

export const PracticalSectionEyeCatch = ({ title, courseTitle, imageRef, sectionId, submissionPlaceUrl }) => {
  const { isSp } = useViewportState();
  return (
    <div styleName="eye-catch">
      <div styleName="image-wrapper">
        <img styleName="image" src={ImageApis.getUrlFor(imageRef)} />
      </div>
      <div styleName="image-overlay" />
      <div styleName="body">
        <div styleName="label">実技試験</div>
        <div styleName="title">{title}</div>
        <div styleName="course-title">{courseTitle}</div>
        {isSp ? (
          <SubmissionBannerForSp sectionId={sectionId} submissionPlaceUrl={submissionPlaceUrl} />
        ) : (
          <SubmissionBannerForDesktop sectionId={sectionId} submissionPlaceUrl={submissionPlaceUrl} />
        )}
      </div>
    </div>
  );
};
